import React, { useMemo } from 'react'

import StepForm from '../../../../../../../features/components/Forms/StepForm'

import { useCreateGamAd } from '../../hooks/useCreateGamAd'

import { IMAGE_EXTERNAL_HOST_TYPE } from '../../fields'
import AdQuarantineField from '../../../../../../ReusableFormFields/AdQuarantineField'

const ExternalImageHostRoute = ({ FormRouteSelector, isInternalAdCreation, ...formProps }) => {
  const { purifiedFormik } = useCreateGamAd({
    isInternalAdCreation,
    formatOption: IMAGE_EXTERNAL_HOST_TYPE
  })

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: () => (
          <div>
            Here will be External host logic
            <AdQuarantineField formik={purifiedFormik} />
          </div>
        ),
        show: true
      }
    ],
    [FormRouteSelector, purifiedFormik]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} />
}

export default ExternalImageHostRoute
